import React, { useMemo } from 'react'
import Button from '@ublique/components/Button'

const HeaderComponent = ({ actions: { selected, empty }, selectedSize }) => {
  const renderButtons = useMemo(() => {
    const actions = selectedSize > 0 ? selected : empty

    return actions.map(({ title, kind, handleClick }, index) => (
      <Button
        onClick={handleClick}
        tooltipAlignment='end'
        tooltipPosition='bottom'
        iconDescription={title}
        kind={kind ?? 'primary'}
        tabIndex={index}
        key={`header-${index}`}
      >
        {title}
      </Button>
    ))
  }, [selected, empty, selectedSize])

  return <div className='users-actions-layout'>{renderButtons}</div>
}

HeaderComponent.defaultProps = {
  actions: {
    selected: [],
    empty: []
  },
  selectedSize: 0
}

export default HeaderComponent
